import React from 'react'
import SbEditable from 'storyblok-react'

const Spacer = (props) => {

    let amount
    
    if (typeof window != 'undefined' && window.innerWidth > 900) {
        amount = props.blok.amount / 10
    } else {
        amount = (props.blok.amount / 10) / 6
    }

    return (
        <SbEditable content={props.blok}>
            <div style={{ height: `${amount}rem` }} />
        </SbEditable>
    )
}

export default Spacer
